import React from "react";
import SwitchRow from "./SwitchRow"; // Make sure this exists
import GeofenceSelector from "./GeofenceSelector";

const defaultFormData = {
  // Clock in and out
  clockInOutViaWeb: false,
  clockInOutViaMobile: false,
  captureGpsOnClockViaMobile: false,
  blockClockingFromOutsideDistance: false,
  clockInOutViaSms: false,
  requirePhotoWhenStartAndEnd: false,
  maximumTimesheetLength: 15,

  // Timesheet Approving
  autoTimeApproveTimesheets: "never",
  automaticallyRound: false,
  roundToScheduleStartIfEarlier: false,
  startTimeRounding: 15,
  endTimeRounding: 15,
  breakTimeRounding: 15,

  // Team Member Permission
  addAndEditTimesheets: false,
  modifyTimesheetsDuringshifts: false,
  startShiftsAnytimeBeforeScheduledTime: false,
  howEarlyTeamMembersCanStartShifts: 5,
  endBreakAnyTime: false,

  // Unscheduled Shifts
  linkUnscheduledTimesheetWith: "best_fit",
  timeVariance: "no_preference",
  requiredUnscheduledTimesheet: false,

  // Breaks
  addScheduledBreaksWhenClockingOut: false,
  displayWarningForShorterOrMissedBreaks: false,
  paidMealBreaks: "unpaid",
};

const EditTimesheet = ({ data, setData }) => {
  // Merge defaults with possibly null/partial data
  const formData = { ...defaultFormData, ...(data || {}) };

  // Handle regular input changes
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setData((prev) => ({
      ...prev,
      [name]:
        type === "number"
          ? Number(value)
          : value === "true"
          ? true
          : value === "false"
          ? false
          : value,
    }));
  };

  // Handle switch toggles
  const handleSwitchChange = (field, value) => {
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <form className="space-y-8">
      {/* Clock in and out */}
      {/* <div className="bg-white px-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          Clock in and out
        </h2>
        <div className="space-y-6">
          <SwitchRow
            label="Clock in and out via web browser"
            checked={formData.clockInOutViaWeb}
            onChange={(val) => handleSwitchChange("clockInOutViaWeb", val)}
          />
          <SwitchRow
            label="Clock in and out via mobile apps"
            checked={formData.clockInOutViaMobile}
            onChange={(val) => handleSwitchChange("clockInOutViaMobile", val)}
          />
          <SwitchRow
            label="Capture GPS location on clock round via mobile"
            description="Timesheets will show how far your team member checked out and clocked in or clocked out."
            checked={formData.captureGpsOnClockViaMobile}
            onChange={(val) =>
              handleSwitchChange("captureGpsOnClockViaMobile", val)
            }
          />
          <SwitchRow
            label="Block (ignorant) clocking from outside a set distance"
            description="GPS clocking is used to calculate where team members are clocking in or clocking out."
            checked={formData.blockClockingFromOutsideDistance}
            onChange={(val) =>
              handleSwitchChange("blockClockingFromOutsideDistance", val)
            }
          />
          {formData.blockClockingFromOutsideDistance && (
            <div className="w-full flex justify-start">
              <GeofenceSelector />
            </div>
          )}

          <SwitchRow
            label="Clock in and out via SMS"
            description='Team members can reply to the shift message and to finish with "start shift", "end shift", "break start" to begin and "finish break", "end break" to finish.'
            checked={formData.clockInOutViaSms}
            onChange={(val) => handleSwitchChange("clockInOutViaSms", val)}
          />
          <SwitchRow
            label="Require a photo when clocking and ending shifts in Kiosk"
            description="Team members must take a photo on the Kiosk when starting and ending their shifts."
            checked={formData.requirePhotoWhenStartAndEnd}
            onChange={(val) =>
              handleSwitchChange("requirePhotoWhenStartAndEnd", val)
            }
          />
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Maximum timesheet length (minutes)
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Timesheets shorter than the minimum length will be blocked.
              </p>
            </div>
            <div>
              <input
                type="number"
                name="maximumTimesheetLength"
                value={formData.maximumTimesheetLength}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              />
            </div>
          </div>
        </div>
      </div> */}
      {/* Team member permissions */}
      <div className="bg-white p-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          Team member permissions
        </h2>
        <div className="space-y-6">
          <SwitchRow
            label="Add and edit timesheets"
            description="Team members can create or amend existing timesheets for themselves in the past."
            checked={formData.addAndEditTimesheets}
            onChange={(val) => handleSwitchChange("addAndEditTimesheets", val)}
          />
          <SwitchRow
            label="Modify timesheets during shifts"
            description="Team members can modify their timesheets before they end shift."
            checked={formData.modifyTimesheetsDuringshifts}
            onChange={(val) =>
              handleSwitchChange("modifyTimesheetsDuringshifts", val)
            }
          />
          <SwitchRow
            label="Start shifts anytime before scheduled time"
            description="If our Team members can start at anytime earlier than their scheduled time."
            checked={formData.startShiftsAnytimeBeforeScheduledTime}
            onChange={(val) =>
              handleSwitchChange("startShiftsAnytimeBeforeScheduledTime", val)
            }
          />
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                How early team members can start shifts (minutes)
              </label>
              <p className="text-xs text-gray-500 mb-2">
                The number of minutes team members can start before their
                scheduled start time.
              </p>
            </div>
            <div>
              <input
                type="number"
                disabled={formData.startShiftsAnytimeBeforeScheduledTime}
                name="howEarlyTeamMembersCanStartShifts"
                value={formData.howEarlyTeamMembersCanStartShifts}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              />
            </div>
          </div>
          <SwitchRow
            label="End breaks anytime"
            description="Team members can end their breaks earlier than the scheduled end time."
            checked={formData.endBreakAnyTime}
            onChange={(val) => handleSwitchChange("endBreakAnyTime", val)}
          />
        </div>
      </div>
      {/* Timesheet approving
      <div className="bg-white p-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          Timesheet approving
        </h2>
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Auto time approve timesheets
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Timesheets can be auto-approved against a sync approval.
              </p>
            </div>
            <div>
              <select
                name="autoTimeApproveTimesheets"
                value={formData.autoTimeApproveTimesheets}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="never">Never</option>
                <option value="up_to_5mins">
                  When variance from schedule is up to 5 minutes
                </option>
                <option value="up_to_10mins">
                  When variance from schedule is up to 10 minutes
                </option>
                <option value="up_to_15mins">
                  When variance from schedule is up to 15 minutes
                </option>
                <option value="up_to_20mins">
                  When variance from schedule is up to 20 minutes
                </option>
                <option value="up_to_30mins">
                  When variance from schedule is up to 30 minutes
                </option>
                <option value="up_to_60mins">
                  When variance from schedule is up to 60 minutes
                </option>
              </select>
            </div>
          </div>
          <SwitchRow
            label="Automatically round timesheets"
            description="Timesheets can be auto-recorded based on the below instructions."
            checked={formData.automaticallyRound}
            onChange={(val) => handleSwitchChange("automaticallyRound", val)}
          />
          <SwitchRow
            label="Round to scheduled start time if earlier"
            description="If 'on', the timesheet will be rounded to the scheduled start time. If start time is later than scheduled, it will be rounded based on the setting below."
            checked={formData.roundToScheduleStartIfEarlier}
            onChange={(val) =>
              handleSwitchChange("roundToScheduleStartIfEarlier", val)
            }
          />
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Start time rounding
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Used when rounding timesheets manually or automatically.
                Rounding the start time later may reduce total hours worked.
              </p>
            </div>
            <div>
              <select
                name="roundToScheduledEndTimeIfLater"
                // value={formData.autoTimeApproveTimesheets}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="no_roundnig">No Rounding</option>
                <option value="closer_5mins">Closer 5 minutes</option>
                <option value="closer_10mins">Closer 10 minutes</option>
                <option value="closer_15mins">Closer 15 minutes</option>
                <option value="closer_20mins">Closer 20 minutes</option>
                <option value="closer_30mins">Closer 30 minutes</option>
                <option value="closer_60mins">Closer 60 minutes</option>
                <option value="earlier_5mins">Earlier 5 minutes</option>
                <option value="earlier_10mins">Earlier 10 minutes</option>
                <option value="earlier_15mins">Earlier 15 minutes</option>
                <option value="earlier_20mins">Earlier 20 minutes</option>
                <option value="earlier_30mins">Earlier 30 minutes</option>
                <option value="earlier_60mins">Earlier 60 minutes</option>
                <option value="later_5mins">Later 5 minutes</option>
                <option value="later_10mins">Later 10 minutes</option>
                <option value="later_15mins">Later 15 minutes</option>
                <option value="later_20mins">Later 20 minutes</option>
                <option value="later_30mins">Later 30 minutes</option>
                <option value="later_60mins">Later 60 minutes</option>
              </select>
            </div>
          </div>
          <SwitchRow
            label="Round to scheduled start time if later"
            description="If 'on', the timesheet will be rounded to the scheduled end time. If end time is earlier than scheduled, it will be rounded based on the setting below."
            checked={formData.roundToScheduleStartIfLater}
            onChange={(val) =>
              handleSwitchChange("roundToScheduleStartIfLater", val)
            }
          />
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                End time rounding
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Used when rounding timesheets manually or automatically.
                Rounding the end time later may reduce total hours worked.
              </p>
            </div>
            <div>
              <select
                name="roundToScheduledEndTimeIfLater"
                // value={formData.autoTimeApproveTimesheets}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="no_roundnig">No Rounding</option>
                <option value="closer_5mins">Closer 5 minutes</option>
                <option value="closer_10mins">Closer 10 minutes</option>
                <option value="closer_15mins">Closer 15 minutes</option>
                <option value="closer_20mins">Closer 20 minutes</option>
                <option value="closer_30mins">Closer 30 minutes</option>
                <option value="closer_60mins">Closer 60 minutes</option>
                <option value="earlier_5mins">Earlier 5 minutes</option>
                <option value="earlier_10mins">Earlier 10 minutes</option>
                <option value="earlier_15mins">Earlier 15 minutes</option>
                <option value="earlier_20mins">Earlier 20 minutes</option>
                <option value="earlier_30mins">Earlier 30 minutes</option>
                <option value="earlier_60mins">Earlier 60 minutes</option>
                <option value="later_5mins">Later 5 minutes</option>
                <option value="later_10mins">Later 10 minutes</option>
                <option value="later_15mins">Later 15 minutes</option>
                <option value="later_20mins">Later 20 minutes</option>
                <option value="later_30mins">Later 30 minutes</option>
                <option value="later_60mins">Later 60 minutes</option>
              </select>
            </div>
          </div>
          <SwitchRow
            label="Round to scheduled break if break duration is shorter"
            description="If 'on', the timesheet will be rounded to the scheduled duration. If break duration is longer than scheduled, it will be rounded based on the setting below."
            checked={formData.roundToScheduleBreakIfShorter}
            onChange={(val) =>
              handleSwitchChange("roundToScheduleBreakIfShorter", val)
            }
          />
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Break time rounding
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Used when rounding timesheets manually or automatically.
                Rounding the break time later may reduce total hours worked.
              </p>
            </div>
            <div>
              <select
                name="breakTimeRounding"
                // value={formData.autoTimeApproveTimesheets}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="no_roundnig">No Rounding</option>
                <option value="closer_5mins">Closer 5 minutes</option>
                <option value="closer_10mins">Closer 10 minutes</option>
                <option value="closer_15mins">Closer 15 minutes</option>
                <option value="closer_20mins">Closer 20 minutes</option>
                <option value="closer_30mins">Closer 30 minutes</option>
                <option value="closer_60mins">Closer 60 minutes</option>
                <option value="earlier_5mins">Earlier 5 minutes</option>
                <option value="earlier_10mins">Earlier 10 minutes</option>
                <option value="earlier_15mins">Earlier 15 minutes</option>
                <option value="earlier_20mins">Earlier 20 minutes</option>
                <option value="earlier_30mins">Earlier 30 minutes</option>
                <option value="earlier_60mins">Earlier 60 minutes</option>
                <option value="later_5mins">Later 5 minutes</option>
                <option value="later_10mins">Later 10 minutes</option>
                <option value="later_15mins">Later 15 minutes</option>
                <option value="later_20mins">Later 20 minutes</option>
                <option value="later_30mins">Later 30 minutes</option>
                <option value="later_60mins">Later 60 minutes</option>
              </select>
            </div>
          </div>
        </div>
      </div> */}
      {/* Unscheduled shifts */}
      {/* <div className="bg-white p-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          Unscheduled shifts
        </h2>
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Link unscheduled timesheet with a scheduled shift
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Unscheduled timesheets can be linked to a scheduled shift if the
                area or location matches. The default option (Best Fit) will
                link when an unscheduled timesheet starts 8 hours before or
                after a scheduled shift.
              </p>
            </div>
            <div>
              <select
                name="linkUnscheduledTimesheetWith"
                value={formData.linkUnscheduledTimesheetWith}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="best_fit">Best Fit (default)</option>
                <option value="match_shift_area">
                  If timesheet Area matches with scheduled shift Area
                </option>
                <option value="match_shift_location">
                  If timesheet Area matches with scheduled shift Location
                </option>
                <option value="shift_within_time_variance">
                  If timesheet is within a time variance of a scheduled shift
                </option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Time variance
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Time unscheduled timesheet with a scheduled shift performed by a
                time variance.
              </p>
            </div>
            <div>
              <select
                name="timeVariance"
                value={formData.timeVariance}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="no_preference">No preference on time</option>
                <option value="60_minutes">
                  Match when timesheet is up to 60 minutes earlier than schedule
                </option>
                <option value="120_minutes">
                  Match when timesheet is up to 120 minutes earlier than
                  schedule
                </option>
                <option value="240_minutes">
                  Match when timesheet is up to 240 minutes earlier than
                  schedule
                </option>
              </select>
            </div>
          </div>
          <SwitchRow
            label="Training requirements must be met when clocking in to nscheduled shifts"
            description="If 'on', team members, including those marked as preferred, must have the appropriate training in order to clock in to areas with training requirements."
            checked={formData.requiredUnscheduledTimesheet}
            onChange={(val) =>
              handleSwitchChange("requiredUnscheduledTimesheet", val)
            }
          />
        </div>
      </div> */}

      {/* Breaks */}
      <div className="bg-white p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-6">Breaks</h2>
        <div className="space-y-6">
          <SwitchRow
            label="Add scheduled breaks when clocking out"
            description="When clocking out, if scheduled breaks were not taken during the shift, automatically add them to the timesheet. Note: If your team does not have access to edit their timesheets, they will not be able to remove these breaks when clocking out."
            checked={formData.addScheduledBreaksWhenClockingOut}
            onChange={(val) =>
              handleSwitchChange("addScheduledBreaksWhenClockingOut", val)
            }
          />
          <SwitchRow
            label="Display warning for shorter or missed breaks"
            description="Display a warning in the timesheet if a scheduled break is shorter or was missed."
            checked={formData.displayWarningForShorterOrMissedBreaks}
            onChange={(val) =>
              handleSwitchChange("displayWarningForShorterOrMissedBreaks", val)
            }
          />
          <div className="grid grid-cols-2 gap-12">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Paid meal breaks
              </label>
              <p className="text-xs text-gray-500 mb-2">
                Meal breaks can be paid or unpaid. We do not recommend using
                this setting - use 'Rest breaks' as a paid break.
              </p>
            </div>
            <div>
              <select
                name="paidMealBreaks"
                value={formData.paidMealBreaks}
                onChange={handleChange}
                className="w-full rounded border-gray-300 bg-slate-100 p-2"
              >
                <option value="unpaid">All Meal breaks are unpaid</option>
                <option value="all_paid">All breaks are paid</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditTimesheet;
